// @ts-nocheck

import React, { useEffect } from "react";
import AboutBharatThakur from "../AboutBharatThakur/AboutBharatThakur";
import Advertisement from "../Advertisement/Advertisement";
import Benefits from "../Benefits/Benefits";
import ClientsReview from "../ClientsReview/ClientsReview";
import FAQ from "../FAQ/FAQ";
import HourDayComparism from "../HourDayComparism/HourDayComparism";
import Nav from "../Nav/Nav";
import OurTeachers from "../OurTeachers/OurTeachers";
import RedBanner from "../RedBanner/RedBanner";
import WhyRed from "../WhyRed/WhyRed";
import "./HomePage.css";
import DownloadEbook from "../DownloadEbook/DownloadEbook";
import DownloadEbooknew from "../DownloadEbook/DownloadEbooknew";
import Footer from "../Footer/Footer";
import JoinNowModal from "../JoinNowModal/JoinNowModal";
import TimeSchedule from "../TimeSchedule/TimeSchedule";
import ThankYouPopUp from "../ThankYouPopUp/ThankYouPopUp";
import TagManager from "react-gtm-module";
import { useLocation } from "react-router-dom";
import StudioOffers from "../StudioOffers/StudioOffers";


  

export default function HomePage() {


	const location = useLocation();

  // Initialize GTM only once (better to do this in App.js)
  useEffect(() => {
    
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      
      const script = document.createElement('script');
      script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-WJNKG7HZ';
      script.async = true;
      document.head.appendChild(script);
    
  }, []);

  // Track component-specific page view
  useEffect(() => {
    window.dataLayer.push({
      event: 'pageView',
      page: location.pathname,
      pageTitle: 'Home Page', // Custom title for this component
      component: 'Home'    // Additional component identifier
    });
  }, [location]);


	// useEffect(() => {
    
	// 	TagManager.initialize({
	// 	  gtmId: 'GTM-WJNKG7HZ',
	// 	  dataLayer: {
	// 		event: 'pageView',
	// 		page: 'thankyou'
	// 	  }
	// 	});
  
	// }, []);

	

	const [modalShow, setModalShow] = React.useState(false);
	const [ShowThanksPopUp, setShowThanksPopUp] = React.useState(false);

    const ThankYouPopUpHide = () => setShowThanksPopUp(false);
    const ThankYouPopUpShow = () => setShowThanksPopUp(true);

	const handleWhatsapp = () => {
		window.open("https://wa.me/971585379978?text=Hi%20", "_blank");
	};
	return (
		<>
			<JoinNowModal ThankYouPopUpShow={ThankYouPopUpShow} show={modalShow} onHide={() => setModalShow(false)} />
			 {/* <ThankYouPopUp ThankYouPopUpHide={ThankYouPopUpHide} ShowThanksPopUp={ShowThanksPopUp} /> */}

			<div id='home'>
				<Nav modalHandler={setModalShow} />
				<div className='px-3 px-sm-5'>
					<RedBanner modalHandler={setModalShow}  />
					<StudioOffers/>
					<ClientsReview />
					<Benefits />
					<Advertisement modalHandler={setModalShow} type={1} />
					<WhyRed />
					<Advertisement modalHandler={setModalShow} type={2} />
					{/* <HourDayComparism /> */}
					<OurTeachers />
					<Advertisement modalHandler={setModalShow} type={3} />
					<AboutBharatThakur />
					<TimeSchedule/>
					<FAQ />
				</div>
				{/* <DownloadEbook /> */}
				<DownloadEbooknew/>
				<Footer />

				<div className="sticky-actions">
					<div className="ChatOptionMobile" onClick={handleWhatsapp}>
						<img width={22} height={20} src="assets/WhatsappGreen.svg" alt=""/><p className="ms-1">Chat with us</p> 
					</div>
					<div className="ChatOptionMobile joinToday-sticky-action" onClick={()=>setModalShow(true)}>
						<img width={22} src="assets/enquire-icon-web.png" alt=""/>
						<p className="ms-1">Join Today</p> 
					</div>
				</div>
			</div>
		</>
	);
}
